<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>Copy Template</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="newName"
          label="New Template Name"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="newDescription"
          label="New Template Description"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        ><v-switch v-model="copyDepartures" label="Copy Departures"
      /></v-col>
      <v-col><v-switch v-model="copyContents" label="Copy Contents" /></v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onCopy" :disabled="!isValid">Copy</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <pre>{{ value }}</pre>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../shared/BasicDialog.vue";
export default {
  name: "copy-template-dialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    BasicDialog,
  },

  data() {
    return {
      debug: false,
      newName: this.value ? `${this.value.name} - Copy` : "",
      newDescription: this.value ? `${this.value.description} - Copy` : "",
      copyDepartures: true,
      copyContents: true,
    };
  },

  computed: {
    isValid() {
      return this.newName && this.newDescription;
    },
  },

  watch: {
    value(newVal) {
      this.newName = newVal ? `${newVal.name} - Copy` : "";
      this.newDescription = newVal ? `${newVal.description} - Copy` : "";
      this.copyContents = true;
      this.copyDepartures = true;
    },
  },

  methods: {
    onCopy() {
      this.$emit("copy", {
        id: this.value.id,
        newName: this.newName,
        newDescription: this.newDescription,
        copyDepartures: this.copyDepartures,
        copyContents: this.copyContents,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/CopyTemplateDialog.vue